module.exports = __webpack_public_path__ + "static/media/49.725186f3.jpg";